module.exports = __webpack_public_path__ + "static/img/goods-400.5a5f9b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/pop/goods-400.png
// module id = rerB
// module chunks = 2